import {useQuery} from 'react-query'
import {ServiceEditModalForm} from './ServiceEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getServiceById} from '../core/_requests'

const ServiceEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: service,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-service-${itemIdForUpdate}`,
    () => {
      return getServiceById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <ServiceEditModalForm isServiceLoading={isLoading} service={{id: undefined}} />
  }

  if (!isLoading && !error && service) {
    console.log({service, },"its service")
    console.log(typeof service,"its service")
    return <ServiceEditModalForm isServiceLoading={isLoading} service={service} />
  }

  return null
}

export {ServiceEditModalFormWrapper}
